import { parseISO, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { logError } from '../api';

// Función que convierte una fecha UTC a la hora local
const convertToLocalDate = (utcDate, timeZone) => {
  if (!utcDate) return utcDate; // Si no es una fecha, retornamos el valor tal cual
  
  try {
    // Aseguramos que la fecha esté en formato ISO
    if (!utcDate.endsWith('Z')) {
      utcDate += 'Z'; // Si no tiene 'Z', la añadimos para indicar que es UTC
    }

    // Parseamos la fecha como UTC
    const utcDateObj = parseISO(utcDate); 
    
    // Verificamos si la fecha es válida
    if (isNaN(utcDateObj)) {
      console.error('Fecha no válida:', utcDate); // Si la fecha no es válida, lo logueamos
      return utcDate; // Devolvemos la fecha original si no es válida
    }

    // Usamos 'toZonedTime' para convertir UTC a la hora local en la zona horaria proporcionada
    const localDate = toZonedTime(utcDateObj, timeZone); 
    
    // Formateamos y devolvemos la fecha en el formato deseado
    return format(localDate, 'yyyy-MM-dd HH:mm:ss');
  } catch (e) {
    logError(e);
    console.error('Error al convertir la fecha:', e);
    return utcDate; // Si algo sale mal, devolvemos la fecha original
  }
};

// Función para formatear una fecha en formato YYYY-MM-DD sin conversión de zona horaria
export const formatDateToYYYYMMDD = (date) => {
  if (!date) return '';
  
  try {
    // Crear una nueva fecha con la fecha local (sin conversión a UTC)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (e) {
    logError(e);
    console.error('Error al formatear la fecha:', e);
    return '';
  }
};

// Función recursiva para recorrer todas las props y convertir las fechas
export const convertDatesInProps = (value, timeZone) => {
  if (Array.isArray(value)) {
    // Si es un array, recorremos todos los elementos y aplicamos la conversión a las fechas
    return value.map((item) => convertDatesInProps(item, timeZone)); // Llamada recursiva
  } else if (typeof value === 'object' && value !== null) {
    // Si es un objeto, recorremos las claves y aplicamos la conversión
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = convertDatesInProps(value[key], timeZone); // Llamada recursiva
      return acc;
    }, {});
  } else if (
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[\+\-]\d{2}:\d{2})?$/.test(value)
  ) {
    return convertToLocalDate(value, timeZone);
  }
  return value; // Si no es un array, objeto ni fecha, devolvemos el valor original
};